import type { SkillCategory, ToolCategory } from "../../types/content";

function LogAnalysisDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <rect x="4" y="4" width="72" height="8" rx="2" fill="var(--surface-alt, #2a2a3a)" />
      <rect x="4" y="16" width="72" height="8" rx="2" fill="var(--accent, #7c6af7)" opacity="0.9" />
      <rect x="4" y="28" width="72" height="8" rx="2" fill="var(--surface-alt, #2a2a3a)" />
      <rect x="4" y="40" width="72" height="8" rx="2" fill="var(--accent, #7c6af7)" opacity="0.9" />
    </svg>
  );
}

function NetworkMapDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <line x1="40" y1="10" x2="16" y2="36" stroke="var(--border, #444)" strokeWidth="1.5" />
      <line x1="40" y1="10" x2="64" y2="36" stroke="var(--border, #444)" strokeWidth="1.5" />
      <line x1="16" y1="36" x2="64" y2="36" stroke="var(--border, #444)" strokeWidth="1.5" />
      <circle cx="40" cy="10" r="7" fill="var(--accent, #7c6af7)" opacity="0.9" />
      <circle cx="40" cy="10" r="10" fill="none" stroke="var(--accent, #7c6af7)" strokeWidth="1.5" />
      <circle cx="16" cy="36" r="7" fill="var(--accent, #7c6af7)" opacity="0.9" />
      <circle cx="16" cy="36" r="10" fill="none" stroke="var(--accent, #7c6af7)" strokeWidth="1.5" />
      <circle cx="64" cy="36" r="7" fill="var(--surface-alt, #2a2a3a)" />
    </svg>
  );
}

function PhishingDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <rect x="8" y="10" width="64" height="34" rx="4" fill="none" stroke="var(--accent, #7c6af7)" strokeWidth="1.5" />
      <polyline points="8,12 40,32 72,12" fill="none" stroke="var(--accent, #7c6af7)" strokeWidth="1.5" />
      <circle cx="62" cy="14" r="9" fill="var(--medium, #e0a83c)" />
      <text x="62" y="18" fontSize="12" fill="var(--surface-1, #111)" textAnchor="middle" fontWeight="700">
        !
      </text>
    </svg>
  );
}

function ReportBuilderDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <rect x="4" y="6" width="72" height="10" rx="2" fill="var(--accent, #7c6af7)" opacity="0.9" />
      <text x="10" y="14" fontSize="7" fill="var(--text-on-accent, #fff)">
        1
      </text>
      <rect x="4" y="20" width="72" height="10" rx="2" fill="var(--surface-alt, #2a2a3a)" />
      <text x="10" y="28" fontSize="7" fill="var(--text-muted, #888)">
        2
      </text>
      <rect x="4" y="34" width="72" height="10" rx="2" fill="var(--surface-alt, #2a2a3a)" />
      <text x="10" y="42" fontSize="7" fill="var(--text-muted, #888)">
        3
      </text>
    </svg>
  );
}

function UpcomingDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <rect x="4" y="4" width="72" height="44" rx="4" fill="var(--surface-alt, #2a2a3a)" opacity="0.5" />
      <text x="40" y="30" fontSize="10" fill="var(--text-muted, #888)" textAnchor="middle">
        soon
      </text>
    </svg>
  );
}

function EconomyDiagram(): JSX.Element {
  return (
    <svg
      viewBox="0 0 80 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={80}
      height={52}
    >
      <circle cx="40" cy="26" r="20" fill="none" stroke="var(--accent, #7c6af7)" strokeWidth="1.5" opacity="0.4" />
      <text x="40" y="30" fontSize="14" fill="var(--accent, #7c6af7)" textAnchor="middle" opacity="0.9">
        +$
      </text>
    </svg>
  );
}

export function MiniEffectDiagram({ category }: { category: ToolCategory | SkillCategory }): JSX.Element {
  switch (category) {
    case "log_analysis":
      return <LogAnalysisDiagram />;
    case "network_map":
      return <NetworkMapDiagram />;
    case "phishing":
      return <PhishingDiagram />;
    case "report_builder":
      return <ReportBuilderDiagram />;
    case "economy":
      return <EconomyDiagram />;
    case "upcoming":
      return <UpcomingDiagram />;
  }
}
